/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ClientNameContainer from '@components/client-name';
import UpdateAppInfo from './update-app-info';

import { homeActions } from '@redux/slices/home';
import { GetDayOfWeek, GetDay, GetMonth } from '@utilities/date-functions';
import { HomeSelector } from '../../selectors';
import { decodeToken } from '@utilities/authentication';
import useWindowDimensions from '@hooks/useWindowDimensions';

const { getGreetingsText, getImagesName, getMotivationalText } = HomeSelector;
import style from './home.module.scss';
import { getGreetingImagesAndText } from '@services/cache-services/greeting';
const Greeting = ({ hasError = false }) => {
  const [closedNotifications, setClosedNotifications] = useState(false);
  const { greetings } = useSelector((state) => state.home);
  const [isVisible, setIsVisible] = useState(true);
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();

  useEffect(() => {
    const data = getGreetingImagesAndText({ greetings });
    data && dispatch?.(homeActions.setGreetings({ data }));

    const intervalId = setInterval(() => {
      const data = getGreetingImagesAndText({ greetings });
      data && dispatch?.(homeActions.setGreetings({ data }));
    }, 1000 * 60 * 60 * 24); // every 24 hours

    return () => clearInterval(intervalId); // ✅ cleanup
  }, []);
  const {
    imageIndex = 0,
    greetingTextIndex = 0,
    motivationalTextIndex = 0
  } = useSelector((state) => state.home?.greetings) || {};

  const isUpdatingAppComplete = useMemo(() => {
    const val = localStorage.getItem('isUpdatingAppComplete') === 'true' ? true : false;
    setClosedNotifications(val);
    setIsVisible(val);
    return val;
  }, [localStorage.getItem('isUpdatingAppComplete')]);

  return (
    <React.Fragment>
      <div
        className={`${style['op-rocketboy']}  ${
          isUpdatingAppComplete && style.rocketboyOnAppUpdate
        } `}
        style={{ backgroundImage: `url(${getImagesName()[imageIndex]})` }}
      />
      {width < 768 && hasError && (
        <div
          id="header"
          className="op-page-name px-4 md:px-8 py-7 flex flex-wrap justify-between items-center dashboard-header"
        >
          {width < 768 && <div></div>}
          <h1 className="h1-semibold" style={{ padding: '0' }}>
            Home
          </h1>
          <div className={`${style['op-day-date']}`}>
            <h4 className="h4">{GetDayOfWeek()}</h4>
            <h3 className="h3">
              {GetMonth()} {GetDay()}
            </h3>
          </div>
        </div>
      )}
      {!hasError && (
        <>
          {width < 768 && <ClientNameContainer clientName={decodeToken()?.clientName} />}

          {width < 768 && closedNotifications && isUpdatingAppComplete && (
            <UpdateAppInfo
              setClosedNotifications={setClosedNotifications}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
            />
          )}
          <div
            id="header"
            className="op-page-name px-4 md:px-8 py-7 flex flex-wrap justify-between items-center dashboard-header"
          >
            {width < 768 && <div></div>}
            <h1 className="h1-semibold" style={{ padding: '0' }}>
              Home
            </h1>
            <div className={`${style['op-day-date']}`}>
              <h4 className="h4">{GetDayOfWeek()}</h4>
              <h3 className="h3">
                {GetMonth()} {GetDay()}
              </h3>
            </div>
          </div>
          {width >= 768 && <ClientNameContainer clientName={decodeToken()?.clientName} />}

          {width >= 768 && closedNotifications && isUpdatingAppComplete && (
            <UpdateAppInfo
              setClosedNotifications={setClosedNotifications}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
            />
          )}
        </>
      )}

      {!hasError && (
        <div
          className={`${style['op-profile-name']} px-4 md:px-8 pt-8`}
          style={{ maxWidth: 'calc(100% - 148px)' }}
        >
          <h1
            className={`${style['h1-bold']} mb-2`}
            style={{
              lineHeight: '32px',
              marginBottom: '8px'
            }}
          >
            {getGreetingsText()[greetingTextIndex]?.text}, {decodeToken().firstName}
            {getGreetingsText()[greetingTextIndex]?.symbol}
          </h1>
          <p className="input-medium">{getMotivationalText()[motivationalTextIndex]}</p>
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(Greeting);
